"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveEntity = exports.publishEvents = exports.getConfigJson = exports.patch = exports.post = exports.get = exports.baseRequestHeaders = exports.SAVE_ENTITY_PATH = exports.EVENTS_PATH = exports.CONFIG_PATH = exports.EVENT_URL = exports.CLIENT_SDK_URL = exports.HOST = void 0;
const utils_1 = require("./utils");
const axios_1 = __importDefault(require("axios"));
const axios_retry_1 = __importDefault(require("axios-retry"));
const axiosClient = axios_1.default.create({
    timeout: 5 * 1000,
    validateStatus: (status) => status < 400 && status >= 200,
});
(0, axios_retry_1.default)(axiosClient, {
    retries: 5,
    // will do exponential retry until axios.timeout
    retryDelay: axios_retry_1.default.exponentialDelay,
    shouldResetTimeout: true,
    retryCondition: (error) => {
        return !error.response || (error.response.status || 0) >= 500;
    }
});
exports.HOST = '.devcycle.com';
exports.CLIENT_SDK_URL = 'https://sdk-api' + exports.HOST;
exports.EVENT_URL = 'https://events' + exports.HOST;
exports.CONFIG_PATH = '/v1/sdkConfig';
exports.EVENTS_PATH = '/v1/events';
exports.SAVE_ENTITY_PATH = '/v1/edgedb';
const baseRequestHeaders = (sdkKey) => {
    return {
        'Content-Type': 'application/json',
        ...(sdkKey ? { 'Authorization': sdkKey } : {})
    };
};
exports.baseRequestHeaders = baseRequestHeaders;
/**
 * Base Requests
 */
const get = async (url) => {
    return await axiosClient.request({
        method: 'GET',
        url: `${url}`,
        headers: (0, exports.baseRequestHeaders)()
    });
};
exports.get = get;
const post = async (url, sdkKey, body) => {
    return await axiosClient.request({
        method: 'POST',
        url,
        data: body,
        headers: (0, exports.baseRequestHeaders)(sdkKey)
    });
};
exports.post = post;
const patch = async (url, sdkKey, body) => {
    return await axiosClient.request({
        method: 'PATCH',
        url,
        data: body,
        headers: (0, exports.baseRequestHeaders)(sdkKey)
    });
};
exports.patch = patch;
/**
 * Endpoints
 */
const getConfigJson = async (sdkKey, user, logger, options, extraParams) => {
    var _a;
    const queryParams = new URLSearchParams({ sdkKey });
    (0, utils_1.serializeUserSearchParams)(user, queryParams);
    if (options === null || options === void 0 ? void 0 : options.enableEdgeDB) {
        queryParams.append('enableEdgeDB', options.enableEdgeDB.toString());
    }
    if (extraParams === null || extraParams === void 0 ? void 0 : extraParams.sse) {
        queryParams.append('sse', '1');
        if (extraParams.lastModified) {
            queryParams.append('sseLastModified', extraParams.lastModified.toString());
        }
        if (extraParams.etag) {
            queryParams.append('sseEtag', extraParams.etag);
        }
    }
    const url = `${(options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.CLIENT_SDK_URL}${exports.CONFIG_PATH}?` + queryParams.toString();
    try {
        const res = await (0, exports.get)(url);
        return res.data;
    }
    catch (ex) {
        const errorString = JSON.stringify((_a = ex === null || ex === void 0 ? void 0 : ex.response) === null || _a === void 0 ? void 0 : _a.data.data.errors);
        logger.error(`Request to get config failed for url: ${url}, ` +
            `response message: ${ex.message}, response data: ${errorString}`);
        throw new Error(`Failed to download DevCycle config. Error details: ${errorString}`);
    }
};
exports.getConfigJson = getConfigJson;
const publishEvents = async (sdkKey, config, user, events, logger, options) => {
    if (!sdkKey) {
        throw new Error('Missing sdkKey to publish events to Events API');
    }
    const payload = (0, utils_1.generateEventPayload)(config, user, events);
    logger.info(`Submit Events Payload: ${JSON.stringify(payload)}`);
    const res = await (0, exports.post)(`${(options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.EVENT_URL}${exports.EVENTS_PATH}`, sdkKey, payload);
    if (res.status >= 400) {
        logger.error(`Error posting events, status: ${res.status}, body: ${res.data}`);
    }
    else {
        logger.info(`Posted Events, status: ${res.status}, body: ${res.data}`);
    }
    return res;
};
exports.publishEvents = publishEvents;
const saveEntity = async (user, sdkKey, logger, options) => {
    if (!sdkKey) {
        throw new Error('Missing sdkKey to save to Edge DB!');
    }
    if (!user || !user.user_id) {
        throw new Error('Missing user to save to Edge DB!');
    }
    if (user.isAnonymous) {
        throw new Error('Cannot save user data for an anonymous user!');
    }
    const res = await (0, exports.patch)(`${(options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.CLIENT_SDK_URL}${exports.SAVE_ENTITY_PATH}/${encodeURIComponent(user.user_id)}`, sdkKey, user);
    if (res.status === 403) {
        logger.warn('Warning: EdgeDB feature is not enabled for this project');
    }
    else if (res.status >= 400) {
        logger.warn(`Error saving user entity, status: ${res.status}, body: ${res.data}`);
    }
    else {
        logger.info(`Saved user entity, status: ${res.status}, body: ${res.data}`);
    }
    return res;
};
exports.saveEntity = saveEntity;
exports.default = {
    get: exports.get,
    post: exports.post,
    getConfigJson: exports.getConfigJson,
    publishEvents: exports.publishEvents
};
//# sourceMappingURL=Request.js.map